import { useMutation } from 'react-query';

import { Pet } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
  petId: string;
};

export const deletePet = ({ petId }: requestDTO): Promise<Pet> => {
  return axios.delete(`parent/pets/${petId}`);
};

type UsePetOptions = {
  config?: MutationConfig<typeof deletePet>;
};

export const useDeletePet = ({ config }: UsePetOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet removed successfully',
      });
    },
    ...config,
    mutationFn: deletePet,
  });
};
